
export const SET_USER_POSTS = 'SET_USER_POSTS';
export const ADD_USER_POSTS = 'ADD_USER_POSTS';
export const SET_QUERY = 'SET_QUERY';
export const SET_CURRENT_ITEM = 'SET_CURRENT_ITEM';
export const FETCH_USER_POSTS_BEGIN   = 'FETCH_USER_POSTS_BEGIN';
export const FETCH_USER_POSTS_SUCCESS = 'FETCH_USER_POSTS_SUCCESS';
export const FETCH_USER_POSTS_FAILURE = 'FETCH_USER_POSTS_FAILURE';
export const UPDATE_USER_OFFER_BEGIN   = 'UPDATE_USER_OFFER_BEGIN';
export const UPDATE_USER_OFFER_SUCCESS = 'UPDATE_USER_OFFER_SUCCESS';
export const UPDATE_USER_OFFER_FAILURE = 'UPDATE_USER_OFFER_FAILURE';
export const UPDATE_CAMPAIGN_COUNTERS = 'UPDATE_CAMPAIGN_COUNTERS';
export const SET_CAROUSEL_ID = "SET_CAROUSEL_ID";
export const SELECT_OBJECT = "SELECT_OBJECT";
export const UNSELECT_OBJECT = "UNSELECT_OBJECT";
export const DESELECT_ALL = "DESELECT_ALL";
export const SELECT_ALL_POSTS = "SELECT_ALL_POSTS";
import { fetchCurrentCampaign } from "./currentCampaign";
import { applyAction } from "./userOffer";
import { trackEvent } from '../../lib/analytics';

export const setCarouselId = (carouselId) => ({
  type: SET_CAROUSEL_ID,
  carouselId
});


export const fetchPostsBegin = (opts) => ({
  type: FETCH_USER_POSTS_BEGIN,
  opts
});

export const fetchPostsSuccess = (posts, opts) => ({
  type: FETCH_USER_POSTS_SUCCESS,
  payload: { posts },
  opts
});

export const fetchPostsFailure = error => ({
  type: FETCH_USER_POSTS_FAILURE,
  payload: { error }
});

export const updateUserOfferBegin = (opts = {}) => (
  {
    type: UPDATE_USER_OFFER_BEGIN,
    opts
  });

export const updateUserOfferSuccess = (user_offer, opts) => ({
  type: UPDATE_USER_OFFER_SUCCESS,
  data: user_offer,
  opts
});

export const updateUserOfferFailure = (error, opts) => ({
  type: UPDATE_USER_OFFER_FAILURE,
  payload: { error },
  opts
});

export const updateCampaignCountersSuccess = (counters, opts) => ({
  type: UPDATE_CAMPAIGN_COUNTERS,
  counters,
  opts
});

export function setQuery(query) {
  return {
    type: SET_QUERY,
    query
  };
}

export function setCurrentItem(item) {
  return (dispatch) => {
    dispatch({ type: SET_CURRENT_ITEM, item });
  };
}

export function selectObject(objectId) {
  return (dispatch) => {
    dispatch({ type: SELECT_OBJECT, objectId });
  };
}
export function unSelectObject(objectId) {
  return (dispatch) => {
    dispatch({ type: UNSELECT_OBJECT, objectId });
  };
}

export function selectAllPosts(objectIds) {
  return (dispatch) => {
    dispatch({ type: SELECT_ALL_POSTS, objectIds });
  };
}

export function unSelectAllObject() {
  return (dispatch) => {
    dispatch({ type: DESELECT_ALL });
  };
}

export function updateUserOffer(id, newAttributes, opts = {}) {
  return (dispatch, getState) => {
    dispatch(updateUserOfferBegin(opts));
    let token = $('meta[name="csrf-token"]').attr('content');
    const { userPostCarousel, userPostCarousel: { carouselId } } = getState();
    let itemRepresenter = userPostCarousel[carouselId].itemRepresenter;
    let userOfferUrl = `/manager/user_offers/${id}.json`;
    fetch(userOfferUrl, {
      body: JSON.stringify({ user_offer: newAttributes, representer: itemRepresenter }),
      method: "PUT",
      headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((data) => { dispatch(updateUserOfferSuccess(data, opts)); })
      .then(() => {
        if (opts.callback) {
          opts.callback();
        }
        if (opts.inAmTool) {
          dispatch(fetchCurrentCampaign({ skip_loading: true }));
        }
        return true;
      })
      .catch(error => dispatch(updateUserOfferFailure(error)));
  };
}

export function fixVideoEncoding(userPostId, opts = {}) {
  return (dispatch, getState) => {
    const { currentCampaign: { campaign: { id } } } = getState();
    let token = $('meta[name="csrf-token"]').attr('content');
    let url = `/manager/campaigns/${id}/user_posts/${userPostId}/fix_video_encoding.json`;
    fetch(url, {
      method: "PUT",
      headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' }
    }).then((response) => response.json()).then((data) => {
      if (data.status == 'done') {
        opts.callback && opts.callback();
        return true;
      } else {
        setTimeout(() => { this.fixVideoEncoding(userPostId, opts) }, 2000)
      }
    })
  }
}

export function rateUserPost(userPostId, rate, opts = {}) {
  return (dispatch, getState) => {
    dispatch(updateUserOfferBegin({ ...opts, id: userPostId }));
    const { currentCampaign: { campaign: { id } } } = getState();
    let url = `/manager/campaigns/${id}/user_posts/${userPostId}/rate.json`;
    let token = $('meta[name="csrf-token"]').attr('content');
    fetch(url, {
      body: JSON.stringify({ stars: rate }),
      method: "POST",
      headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((data) => {

        dispatch(updateUserOfferSuccess(data, { ...opts, id: userPostId })); })
      .then(() => {
        trackEvent('Rate Post', 'Campaign Management');
        if (opts.callback) {
          opts.callback();
        }
        if (opts.inAmTool) {
          dispatch(fetchCurrentCampaign({ skip_loading: true }));
        }
        return true;
      })
      .catch(error => dispatch(updateUserOfferFailure(error, { ...opts, id: userPostId })));
  };
}

export function applyUserOfferAction(actionType, userOfferId, opts = {}) {
  return (dispatch, getState) => {
    dispatch(updateUserOfferBegin(opts));
    const { userPostCarousel, userPostCarousel: { carouselId } } = getState();
    let itemRepresenter = userPostCarousel[carouselId].itemRepresenter;
    dispatch(applyAction(actionType, { ...opts, id: userOfferId,
      extraParams: { representer: itemRepresenter, ...(opts.extraParams || {}) },
      onSuccess: (data) => {
        dispatch(updateUserOfferSuccess(data, opts));
        if (opts.callback) {
          opts.callback();
        }
        trackEvent(actionType, 'Campaign Management', { actionType: 'Group Action' });
      } }));

  };
}

export function fetchUserPosts(opts = {}) {
  return (dispatch, getState) => {
    dispatch(fetchPostsBegin(opts));
    const { userPostCarousel, userPostCarousel: { carouselId } } = getState();
    let query = userPostCarousel[carouselId].query;
    let url = `${query && query.url ? query.url : opts.query && opts.query.url}/search.json`;
    let token = $('meta[name="csrf-token"]').attr('content');
    let newQuery = { ...query, ...opts.query, default_id: opts.default_id };
    delete newQuery.url;
    fetch(url, {
      body: JSON.stringify(newQuery),
      method: "POST",
      headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((data) => { dispatch(fetchPostsSuccess(data, opts)); })
      .then(() => {
        if (opts.callback) {
          opts.callback();
        }
        return true;
      })
      .catch(error => dispatch(fetchPostsFailure(error)));
  };
}
export function updateCampaignCounters(opts = {}) {
  return (dispatch, getState) => {
    const { userPostCarousel, userPostCarousel: { carouselId } } = getState();
    let query = userPostCarousel[carouselId].query;
    let url = `${query && query.url ? query.url : opts.query && opts.query.url}/counters.json`;
    let token = $('meta[name="csrf-token"]').attr('content');

    fetch(url, {
      body: JSON.stringify({}),
      method: "POST",
      headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' } })
      .then((response) =>     response.json())
      .then((data) => { dispatch(updateCampaignCountersSuccess(data, opts)); })
      .then(() => {
        if (opts.callback) {
          opts.callback();
        }
        return true;
      })
      .catch(error => dispatch(fetchPostsFailure(error)));
  };
}
